import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "container mx-auto p-2"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "text-3xl font-bold" }, "写真の詳細", -1);
const _hoisted_3 = { class: "flex flex-row flex-wrap py-4" };
const _hoisted_4 = { class: "w-full px-2 text-left sm:w-1/3 md:w-1/4" };
const _hoisted_5 = { class: "sticky top-0 w-full rounded-xl bg-white p-4" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-lg font-semibold" }, "ステータス", -1);
const _hoisted_8 = ["id", "value"];
const _hoisted_9 = ["for"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("h2", { class: "text-lg font-semibold" }, "タグ", -1);
const _hoisted_12 = ["id", "checked", "onClick"];
const _hoisted_13 = ["for"];
const _hoisted_14 = {
    role: "main",
    class: "w-full px-2 pt-1 sm:w-2/3 md:w-3/4"
};
const _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LinkButton = _resolveComponent("LinkButton");
    return (_ctx.photo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("aside", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.photo.formatCreatedAt()), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.users[_ctx.photo.data.uid]?.getRealName() || "Unknown"), 1),
                            _createElementVNode("div", null, "👍 " + _toDisplayString(_ctx.likesIndexedByPhotoId[_ctx.photo.id]?.likeCount || 0), 1)
                        ]),
                        _hoisted_6,
                        _hoisted_7,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoFilters.filter((filter) => filter.photoStatus), (filter, k) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "nav-item",
                                key: k
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "photoStatus",
                                    id: 'status_' + k,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.photoStatus) = $event)),
                                    value: filter.photoStatus
                                }, null, 8, _hoisted_8), [
                                    [_vModelRadio, _ctx.photoStatus]
                                ]),
                                _createElementVNode("label", {
                                    for: 'status_' + k
                                }, _toDisplayString(filter.name), 9, _hoisted_9)
                            ]));
                        }), 128)),
                        _hoisted_10,
                        _hoisted_11,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTags, (tag, k) => {
                            return (_openBlock(), _createElementBlock("div", { key: k }, [
                                _createElementVNode("div", {
                                    class: "m-px inline-block h-3 w-3 rounded-md",
                                    style: _normalizeStyle({ 'background-color': tag.color })
                                }, null, 4),
                                _createElementVNode("input", {
                                    type: "checkbox",
                                    id: 'tag_' + k,
                                    checked: !!_ctx.photoTagObj[tag.id]?.data,
                                    onClick: ($event) => (_ctx.updateTag(tag.id, $event))
                                }, null, 8, _hoisted_12),
                                _createElementVNode("label", {
                                    for: 'tag_' + k
                                }, _toDisplayString(tag.data.name), 9, _hoisted_13)
                            ]));
                        }), 128)),
                        _createVNode(_component_LinkButton, {
                            class: "mt-3",
                            path: "photos",
                            name: "一覧へ"
                        })
                    ])
                ]),
                _createElementVNode("main", _hoisted_14, [
                    _createElementVNode("img", {
                        src: _ctx.photo.photoUrl
                    }, null, 8, _hoisted_15)
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
